import React, { useEffect } from 'react';
// import ReactGA from 'react-ga4';

const Step5 = ({ formData, handleInputChange, setStep }) => {
  useEffect(() => {
    // const pageName = 'Step5';
    // ReactGA.event({
    //   category: 'Navigation',
    //   action: 'Page View',
    //   page_name: pageName
    // });
    sessionStorage.setItem('lastPage', 'Step5');
  }, []);

  const handleFormSubmit = (answer) => {
    handleInputChange({ target: { name: 'parentHipFracture', value: answer === 'yes' } });
    setStep(7);
  };

  return (
    <div className="p-4 bg-blue-100 rounded-lg">
      <h2 className="common-title mb-4">ステップ 5</h2>
      <p className="text-base mb-4 text-lg">ご両親が太ももの付け根(股関節)を骨折したことはありますか？<br /><br />
        <span className="underline-wavy text-red-500">※不明な場合は、「いいえ」を選んでください。</span>
      </p>
      <br />
      <div className="flex justify-between">
        <button 
          onClick={() => setStep(5)} 
          className="bg-gray-500 text-white p-2 rounded hover:bg-gray-600 w-auto"
        >
          前の画面へもどる
        </button>
        <button 
          onClick={() => handleFormSubmit('yes')} 
          className="bg-blue-500 text-white p-2 rounded hover:bg-blue-600 w-auto"
        >
          はい
        </button>
        <button 
          onClick={() => handleFormSubmit('no')} 
          className="bg-pink-500 text-white p-2 rounded hover:bg-pink-600 w-auto"
        >
          いいえ
        </button>
      </div>
    </div>
  );
};

export default Step5; 